export const filtrarUbicationMovements = (
  listUbicationProvider,
  values,
  nameObj
) => {
  return listUbicationProvider?.filter(
    (prove) => prove.entidadId === values?.[nameObj]
  );
};
